var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fragment" }, [
    _c("div", {
      staticClass: "fragment-content",
      domProps: { innerHTML: _vm._s(_vm.getContent(_vm.slotName)) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }